/**
 * ============================================================
 * CDS — Formatage des prix (utilitaire commun)
 * Studio  : Chlo' Design Studio
 * Version : 1.0
 * Desc.   : Source unique de formatage des prix côté client,
 *           partagée par toutes les sections CDS (favoris,
 *           produit vedette, fiche produit, assembleurs...).
 *           Réplique le filtre money de Shopify à partir du
 *           money_format de la boutique, avec gestion des
 *           placeholders standard. Si un formateur officiel
 *           (window.Shopify.formatMoney, injecté par certaines
 *           apps) existe, il est utilisé en priorité pour
 *           rester homogène avec le reste de la boutique.
 * API     : window.CDSMoney.format(cents, moneyFormat)
 * ============================================================
 */
(function () {
  'use strict';
  if (window.CDSMoney) return;

  var NBSP = ' ';

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseFloat(cents);
    if (isNaN(cents)) cents = 0;
    var value = (cents / 100).toFixed(precision);
    var parts = value.split('.');
    var head = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var tail = parts[1] ? decimal + parts[1] : '';
    return head + tail;
  }

  function format(cents, moneyFormat) {
    if (
      typeof window.Shopify !== 'undefined' &&
      typeof window.Shopify.formatMoney === 'function' &&
      window.Shopify.formatMoney !== format
    ) {
      try {
        return window.Shopify.formatMoney(cents, moneyFormat || '');
      } catch (e) { /* on retombe sur l'implémentation locale */ }
    }

    var fmt = moneyFormat || '{{ amount_with_comma_separator }}' + NBSP + '€';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount_with_comma_separator';
    var value;

    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, NBSP, ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, NBSP, ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, NBSP, '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, '.', ',');
    }

    return fmt
      .replace(new RegExp('\\{\\{\\s*' + placeholder + '\\s*\\}\\}', 'g'), value)
      .replace(/<[^>]+>/g, '')
      .trim();
  }

  window.CDSMoney = { format: format };
})();
